module.exports = __webpack_public_path__ + "img/CY.e8d81006.svg";